import { useQuery } from "react-query";
import {
  getOfflineActiveSync,
  getOfflineSyncStatus,
} from "../../../services/offlineMode";

export const useGetOfflineSyncStatus = ({ id = null }) => {
  return useQuery(
    ["getOfflineSyncStatus", id],
    () => getOfflineSyncStatus(id).then((res) => res?.data?.data),
    { enabled: id ? true : false },
  );
};

export const useGetOfflineActiveSync = () => {
  return useQuery(
    ["getOfflineActiveSync"],
    () => getOfflineActiveSync().then((res) => res?.data?.data),
    { staleTime: Infinity },
  );
};
